export const LogsTypes = {
  SHOW_LOGS: "SHOW_LOGS",
};
